module.exports = __webpack_public_path__ + "img/M-OFF-1.bc022d25.gif";